jQuery(function($) {
	// FacetWP Pager scroll to top
	$(document).on("facetwp-loaded", function() {
		if (FWP.loaded) {
			$("html, body").animate(
				{
					scrollTop: $(".facetwp-template").offset().top,
				},
				500,
			);
		}
	});
	$(".js-hamburger").on("click", function(e) {
		e.preventDefault();
		$(this).toggleClass("is-active");
		$("#dropdownMenu").toggleClass("active");
	});

	$("#main-menu li").each(function() {
		const haveChildren = $(this).find(">ul").length > 0;
		const arrow = '<span class="expand"></span>';
		if (haveChildren) {
			$(this)
				.find(">a")
				.append(arrow);
		}
	});

	// $(document).on("click", ".expand", function(e) {
	// 	e.stopPropagation();
	// 	const $parent = $(this).parents("li");
	// 	const $ul = $parent.find(">ul");
	// 	const $a = $parent.find(">a");
	// 	const isHidden = $ul.height() === 0;
	// 	if (isHidden) {
	// 		$ul.addClass("active");
	// 		$a.addClass("active");
	// 	} else {
	// 		$ul.removeClass("active");
	// 		$a.removeClass("active");
	// 	}
	// });

	$("#main-menu li.menu-item-has-children > a").on("click", function(e) {
		e.preventDefault();
		$(this).toggleClass("active");
		$(this)
			.next(".sub-menu")
			.toggleClass("active");
		$(this)
			.find(".expand")
			.toggleClass("active");
	});
});

function _calculateScrollbarWidth() {
	document.documentElement.style.setProperty(
		"--scrollbar-width",
		window.innerWidth - document.documentElement.clientWidth + "px",
	);
}
// recalculate on resize
window.addEventListener("resize", _calculateScrollbarWidth, false);
// recalculate on dom load
document.addEventListener("DOMContentLoaded", _calculateScrollbarWidth, false);
// recalculate on load (assets loaded as well)
window.addEventListener("load", _calculateScrollbarWidth);

window.TTGHelpers = {
	isInViewport: function(element) {
		const rect = element.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight)
		);
	},
};



// WEBPACK FOOTER //
// ./js/app.js